export default __webpack_public_path__ + "static/media/fairy.d86dfa22.png";